import Header from "./components/header/Header";
import Doctors from "./components/main/Doctors";

function App() {
  return (
    <div>
      <Header/>
      <Doctors/>      
    </div>
  );
}

export default App;
